<div class="filter_dropdown atoz" *ngIf="!isMobileFilter">
    <button class="filter_dropdown--btn sort-drop-down-btn" (click)="clickSorting()"
        [ngClass]="{'down': sortOrderState !== 'desc' ,'up': sortOrderState === 'desc','sorting_btn_active': isActiveState(sortOrderState) }">
        <span *ngIf="sortOrderState != 'desc'"> {{'gamingComp.atoz' | translate}}</span>
        <span *ngIf="sortOrderState === 'desc'"> {{'gamingComp.ztoa' | translate}}</span>
        <i class="icon icon-dropdown-arrow"></i>
    </button>
</div>
<ng-container *ngIf="isMobileFilter">
    <ul class="game_filter_dropdown--ul"  [ngClass]="{'active': isActiveState(sortOrderState)}">
        <li class="active" (click)="clickSorting()"
        [ngClass]="{'down': sortOrderState === 'desc'}">
          <span class="game_filter_dropdown--title icon-dropdown-arrow">{{'gamingComp.sortBy' | translate}}</span>
          <span *ngIf="sortOrderState != 'desc'" class="game_filter_dropdown--desc">{{'gamingComp.atoz' | translate}}</span>
          <span *ngIf="sortOrderState === 'desc'" class="game_filter_dropdown--desc">{{'gamingComp.ztoa' | translate}}</span>
        </li>
    </ul>   
</ng-container>